export const submittingStates = {
  idle: 'idle',
  submitting: 'submitting',
  success: 'success',
  error: 'error',
};
